import { applyMerge, applyDim, applyScalar } from "./apply.js";
const multiplyOp = (a, b) => a * b;
/**
 * @internal
 * @param a
 * @param b
 * @param c
 * @returns
 */
export function multiply(a, b, c) {
    // @ts-ignore
    return applyMerge(multiplyOp, a, b, c);
}
/**
 * Multiplies all components of `rect` by `amount`.
 * This includes x,y if present.
 *
 * ```js
 * multiplyScalar({ width:10, height:20 }, 2); // { width:20, height: 40 }
 * multiplyScalar({ x: 1, y: 2, width:10, height:20 }, 2); // { x: 2, y: 4, width:20, height: 40 }
 * ```
 *
 * Use {@link multiplyDim} to only multiply width & height.
 * @param rect
 * @param amount
 */
export function multiplyScalar(rect, amount) {
    return applyScalar(multiplyOp, rect, amount);
    // return isPositioned(rect) ? Object.freeze({
    //   ...rect,
    //   x: rect.x * amount,
    //   y: rect.y * amount,
    //   width: rect.width * amount,
    //   height: rect.height * amount,
    // }) : Object.freeze({
    //   ...rect,
    //   width: rect.width * amount,
    //   height: rect.height * amount,
    // });
}
/**
 * Multiplies only the width/height of `rect`, leaving `x` and `y` as they are.
 * ```js
 * multiplyDim({ x:1,y:2,width:3,height:4 }, 2);
 * // Yields: { x:1, y:2, width:6, height: 8 }
 * ```
 *
 * In comparison, {@link multiply} will also include x & y.
 * @param rect Rectangle
 * @param amount Amount to multiply by
 * @returns
 */
export function multiplyDim(rect, amount) {
    return applyDim(multiplyOp, rect, amount);
    // return isPositioned(rect) ? Object.freeze({
    //   ...rect,
    //   x: rect.x * amount,
    //   y: rect.y * amount,
    //   width: rect.width * amount,
    //   height: rect.height * amount,
    // }) : Object.freeze({
    //   ...rect,
    //   width: rect.width * amount,
    //   height: rect.height * amount,
    // });
}
